import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cef_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const isAuthed = () => !!localStorage.getItem("cef_admin_token");
export const setToken = (t) => localStorage.setItem("cef_admin_token", t);
export const clearToken = () => localStorage.removeItem("cef_admin_token");
